const e=async(e,t,n)=>{let{data:r}=await e.get(`/orgs/${n}/apps/${t}/roles`);return r.data};export{e as getOrgAppRoles};
//# sourceMappingURL=get-org-app-roles.mjs.map